/**
 * AI chat drawer width model.
 *
 * The chat sits outside the panel allocator — it is a drawer to the left of
 * the nav rail, not a stage panel, so it carries independent pixel bounds.
 * Opening it costs the stage that width; the slide is the only animation, and
 * panels re-allocate for the live stage width it leaves on each frame.
 *
 * Bounds: the minimum is a readable transcript line, the maximum stops the
 * drawer from swallowing the stage on a laptop screen.
 */

export const CHAT_MIN = 280;
export const CHAT_MAX = 640;
export const CHAT_DEFAULT = 380;

export function clampChatWidth(px: number): number {
    if (!Number.isFinite(px)) {
        return CHAT_DEFAULT;
    }
    return Math.min(Math.max(px, CHAT_MIN), CHAT_MAX);
}
